import { IServicePeriods } from '../../../../../redux/reducers';
import { IPublishOptionSchema } from '../../internalTypes';
import { mapPeriod } from '../mapPeriod';

export function mapPeriods(periods: IPublishOptionSchema[]): IServicePeriods {
  return periods.reduce((acc, rawPeriod) => {
    const period = mapPeriod(rawPeriod);

    acc[period.id] = period;

    return acc;
  }, {} as IServicePeriods);
}
